// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"baq_a"};